<template>
    <v-container grid-list-xl>
        <v-layout row wrap>
            <v-flex xs6>
                <h1>Preview Imported Rows</h1>
            </v-flex>
            <v-flex v-if="disabled === false" xs6 class="text-right">
                <v-btn color="green" dark @click="uploadToTask">Confirm Import</v-btn>
                <v-btn color="primary" class="ml-2" outlined depressed dark to="/map">Cancel</v-btn>
            </v-flex>
            <v-flex v-else xs6 class="text-right">
                Saving<br />
                <v-progress-circular
                    indeterminate
                    color="success"
                    v-if="disabled"
                ></v-progress-circular>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="importedRows"
                        item-key="name"
                        multi-sort
                        class="elevation-1">
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        name: 'ActiveTasks',
        data () {
            return {
                disabled: false
            }
        },

        methods: {
            ...mapActions({
                importToTaskTable: 'imports/importFileForTaskTable',
            }),
            async uploadToTask () {
                this.disabled = true
                await this.importToTaskTable(this.importedRows[0].importKey)
                this.disabled = false
                await this.$router.push('/map')
            }
        },
        computed: {
            ...mapGetters({
                headers: 'imports/headers',
                error: 'imports/error',
                importedRows: 'imports/importedRows'
            })
        }
    }
</script>
